class Song < ApplicationRecord
  belongs_to :dance
end
